import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
import { AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
export function PageHydration() {
  return <Page pageNumber={20} variant="light" data-id="element-1443" data-mp="26vw83h8ab33w">
      <div className="flex flex-col h-full" data-id="element-1444" data-mp="26uuy7g308mnr">
        {/* Hero image */}
        <div className="relative h-[240px] -mx-12 -mt-10 mb-8 overflow-hidden" data-id="element-1445" data-mp="22u15m9emajoj">
          <img src="https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=1000&q=80" alt="Glass of water" className="w-full h-full object-cover" data-id="element-1446" data-mp="1xw9hzrl09jq5" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1447" data-mp="1nx1sy74ws0n7" />
          <div className="absolute bottom-4 left-12" data-id="element-1448" data-mp="1jx9tcjxht4tz">
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-1449" data-mp="1jykwqin10akk">
              <span className="text-tealslate" data-id="element-1450" data-mp="3ib1mvjlows3v">Hydration</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8 max-w-lg" data-id="element-1451" data-mp="3e84yfc9gy1s0">
          GLP-1 medications blunt your thirst mechanism just like they blunt
          your appetite. You will not feel thirsty even when you are dehydrated.
          You have to drink water intentionally.
        </p>

        <div className="grid grid-cols-2 gap-6 mb-6" data-id="element-1452" data-mp="2h5fuszbldvvy">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1453" data-mp="2l46kwmhn4d9k">
            <div className="flex items-center gap-2 mb-3" data-id="element-1454" data-mp="38uj26nyrzmct">
              <AlertTriangleIcon className="w-4 h-4 text-[#C4956A]" data-id="element-1455" data-mp="38vavfs4wh7zx" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-1456" data-mp="3dskgkvl9axhy">
                Signs of Dehydration
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-1457" data-mp="301yyh93mmrl4">
              {['Headaches', 'Fatigue', 'Dizziness', 'Constipation', 'Dark urine'].map((s, i) => <li key={i} className="flex items-center gap-2 text-xs text-[#3B3B3B]" data-id="element-1458" data-mp="eh78csoaxig" data-mpi={i}>
                  <span className="w-1.5 h-1.5 bg-tealslate rounded-full" data-id="element-1459" data-mp="aa654w2v24g0" />
                  {s}
                </li>)}
            </ul>
          </div>
          <div className="bg-tealslate/10 border border-tealslate/20 p-5" data-id="element-1460" data-mp="19i0grzcxgfs">
            <div className="flex items-center gap-2 mb-3" data-id="element-1461" data-mp="3sgb19uq8ndjs">
              <CheckCircle2Icon className="w-4 h-4 text-tealslate" data-id="element-1462" data-mp="3sfswg9pifr09" />
              <h3 className="font-bold text-[#1F1F1F] text-sm" data-id="element-1463" data-mp="3nhhmlyz7tgi1">
                Practical Tips
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-1464" data-mp="3ioydbe7k97j1">
              {['Carry a water bottle everywhere', 'Drink a glass before every meal', 'Flavor with lemon or lime if needed'].map((s, i) => <li key={i} className="flex items-start gap-2 text-xs text-[#3B3B3B]" data-id="element-1465" data-mp="34qgqdiphbz26" data-mpi={i}>
                  <span className="w-1.5 h-1.5 bg-tealslate rounded-full mt-1 shrink-0" data-id="element-1466" data-mp="2zsyilvn77pvr" />
                  {s}
                </li>)}
            </ul>
          </div>
        </div>

        <SupplementCallout title="Electrolytes" description="Reduced food intake means fewer electrolytes from meals. An electrolyte supplement helps maintain sodium, potassium, and magnesium levels." data-id="element-1467" data-mp="2uli6h6j3izfw" />
      </div>
    </Page>;
}